import './css/reset.css'
import './css/base.css'

import './css/badge.css'
import './css/breadcrumb.css'
import './css/button.css'
import './css/filter.css'
import './css/form.css'
import './css/grid.css'
import './css/header.css'
import './css/item.css'
import './css/overlay.css'
import './css/row.css'
import './css/search.css'
import './css/share.css'
import './css/splash.css'
import './css/tabs.css'
import './css/tag.css'
import './css/votes.css'
import './css/image.css'
import './css/text.css'
import './css/checkbox.css'

import 'whatwg-fetch'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render (h) {
    return h(App)
  }
})



// WEBPACK FOOTER //
// ./src/main.js